<template>
    <div :class="['card-lite card-lite__background']" :style="[{'width': width+'px', 'height': height+'px'}]">
        <slot name="image"></slot>
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "CardLite",
    props: {
        width: {
            type: Number,
            required: false
        },
        height: {
            type: Number,
            required: false
        }
    }
};
</script>